const {Component, createRef} = window.wp.element;
const {__} = window.wp.i18n;

require("formBuilder");

/* 
The order of the imports and requires is very important, especially in the online enviornment.
The two jQuery libraries must be imported using Node's require(), and not ES6 import.
Also, these two requires MUST come after setting the global jQuery and $ symbols.

In my Babel/Webpack project, the type and order of the imports is a little less sensitive.
For my project, the following alternative works:

    import $ from 'jquery';
    import React from 'react';
    import ReactDOM from 'react-dom';
    import 'jquery-ui-sortable';

    window.jQuery = $;
    window.$ = $;

    require('formBuilder');
*/

class WiNewFormBuilder extends Component
{

	constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.state = {
            form_data: {},
            isLoaded: false,
            error: ''
        };
        this.fb = createRef();
        this.builder = '';
        this.post_id = document.getElementById('post_ID').value
    }
    handleChange() {
        setTimeout(() => {
            console.log(this.state.form_data)
            this.form_data = this.builder.actions.getData()

            fetch(ajaxurl+'?action=wif_forms_save_form&id='+this.post_id, {
                method: 'POST',
                body: JSON.stringify({
                    id: this.post_id,
                    data: this.form_data
                })
            })
            .then(res => res.json())
            .then(
                (result) => {

                    if(result.success) {
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
            
        }, 500)
    }
    componentDidMount() {

        let formOptions = { 
            disabledActionButtons: ['data', 'save'], 
            formData: this.state.form_data, 
            onCloseFieldEdit: this.handleChange, 
            onOpenFieldEdit: this.handleChange, 
            onAddField: this.handleChange, 
            onClearAll: this.handleChange,
            fieldRendered: this.handleChange,
            subtypes: {
                text: ['time']
            }
        }
        let post_id = document.getElementById('post_ID').value
        fetch(ajaxurl+'?action=wif_forms_get_form', {
            method: 'POST',
            body: JSON.stringify({
                id: post_id
            })
        })
        .then(res => res.json())
        .then(
            (result) => {

                if(result.success) {
                    this.setState({
                        isLoaded: true,
                        form_data: result.data
                    });
                    formOptions.formData = this.state.form_data
                    this.builder = jQuery(this.fb.current).formBuilder(formOptions);
                }
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        )
        
    }
    render() {
        const {form_data, isLoaded, error} = this.state

        if( ! isLoaded ) {
            return (
                <div>Loading.....</div>
            );
        }
        return (
        	<div id="fb-editor" ref={this.fb} />
        );
    }
}

export default WiNewFormBuilder;